import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../..";
import { LegsTrackingAPIResponse } from "../HigherAwardTrackingAPI.types";

type hatLegsTrackingParams = {
  abo: string;
  aff: string;
  period: string;
  locale: string;
  inMarketOnly: string;
  useGarAuth: string;
  isoCountryCode: string;
};

export const legsTrackingAPI = createApi({
  reducerPath: "legsTrackingAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getLegsTracking: builder.query<LegsTrackingAPIResponse & { statusCode: number }, hatLegsTrackingParams>({
      queryFn: async (params, api, extraOptions, baseQuery) => {
        const { abo, aff, period, locale, inMarketOnly, useGarAuth, isoCountryCode } = params;
        const queryParams = new URLSearchParams({
          Abo: abo,
          Aff: aff,
          Period: period,
          Locale: locale,
          InMarketOnly: inMarketOnly,
          UseGarAuth: useGarAuth,
          IsoCountryCode: isoCountryCode,
        });

        const result = await baseQuery({
          url: `/hat-faa/api/hatqlegs?${queryParams}`,
          method: "GET",
        });
        const statusCode = (result?.meta as any)?.response?.status || (result?.error as any).status || 0;

        if (result.error) {
          return { error: { ...result.error, statusCode } };
        }

        return {
          data: {
            ...(result.data as LegsTrackingAPIResponse),
            statusCode: statusCode,
          },
        };
      },
    }),
  }),
});

export const { useGetLegsTrackingQuery } = legsTrackingAPI;
